import React, { useState } from 'react';

const ResidentialUnitsContainer = ({ units, selectedCompanyId, onAddUnit, onUpdateUnit, onDeleteUnit, onOpenFormModal }) => {
  const [expandedRow, setExpandedRow] = useState(null);


  return (
    <div className="p-6 h-full flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-gray-600">
          Gestiona las unidades residenciales de esta empresa
        </p>
        <button
          onClick={onOpenFormModal}
          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md font-medium transition-colors flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ingresar Unidad
        </button>
      </div>

      {/* Tabla de unidades residenciales */}
      <div className="flex-1 overflow-auto">
        {units.length === 0 ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center text-gray-400">
              <p className="text-lg">Este company patner no tiene unidades residenciales registradas</p>
            </div>
          </div>
        ) : (
          <table className="min-w-full bg-white">
            <thead className="sticky top-0 bg-gray-100">
              <tr className="text-gray-600 uppercase text-sm leading-normal">
                <th className="py-3 px-4 text-left">Nombre</th>
                <th className="py-3 px-4 text-left">Ciudad</th>
                <th className="py-3 px-4 text-left">Email</th>
                <th className="py-3 px-4 text-left">Teléfono</th>
                <th className="py-3 px-4 text-left">Viviendas</th>
                <th className="py-3 px-4 text-left">% Negocio</th>
                <th className="py-3 px-4 text-center">Métodos Pago</th>
                <th className="py-3 px-4 text-center">Acciones</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm">
              {units.map((unit) => (
                <React.Fragment key={unit.id}>
                  <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                    <td className="py-3 px-4 text-left font-medium">{unit.name}</td>
                    <td className="py-3 px-4 text-left">{unit.ciudad}</td>
                    <td className="py-3 px-4 text-left">{unit.email_unidad}</td>
                    <td className="py-3 px-4 text-left">{unit.telefono || '-'}</td>
                    <td className="py-3 px-4 text-left">{unit.number_homes || 0}</td>
                    <td className="py-3 px-4 text-left">{unit.businness_unidad || 0}%</td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center space-x-1">
                        {unit.banco && (
                          <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium" title="Datos bancarios completos">
                            🏦 Banco
                          </span>
                        )}                        
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedRow(expandedRow === unit.id ? null : unit.id);
                          }}
                          className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs font-medium transition-colors"
                          title="Ver detalles de pago"
                        >
                          {expandedRow === unit.id ? '▲' : '▼'}
                        </button>
                      </div>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <button
                          onClick={() => onUpdateUnit(unit.id)}
                          className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors"
                        >
                          Actualizar
                        </button>
                        <button
                          onClick={() => onDeleteUnit(unit.id)}
                          className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors"
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                  {/* Fila expandida con detalles de pago */}
                  {expandedRow === unit.id && (
                    <tr className="bg-gray-50">
                      <td colSpan="8" className="py-4 px-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {/* Datos Bancarios */}
                          <div className="bg-white p-4 rounded-lg border border-gray-200">
                            <h5 className="font-semibold text-gray-700 mb-3 flex items-center">
                              🏦 Datos Bancarios
                              {unit.banco && <span className="ml-2 text-green-600 text-sm">(✓ Completo)</span>}
                            </h5>
                            {unit.banco ? (
                              <div className="space-y-2 text-sm">
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Banco:</span>
                                  <span className="text-gray-800">{unit.banco}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Nº Cuenta:</span>
                                  <span className="text-gray-800">{unit.numero_Cuenta || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Tipo:</span>
                                  <span className="text-gray-800">{unit.tipo_Cuenta || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Titular:</span>
                                  <span className="text-gray-800">{unit.nombre_Titular || '-'}</span>
                                </div>
                              </div>
                            ) : (
                              <p className="text-gray-500 text-sm italic">No hay datos bancarios registrados</p>
                            )}
                          </div>

                          {/* Datos Breve */}
                          <div className="bg-white p-4 rounded-lg border border-gray-200">
                            <h5 className="font-semibold text-gray-700 mb-3 flex items-center">
                              💳 Datos Breve
                              {unit.type_LLave && <span className="ml-2 text-blue-600 text-sm">(✓ Completo)</span>}
                            </h5>
                            {unit.type_LLave ? (
                              <div className="space-y-2 text-sm">
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Tipo Llave:</span>
                                  <span className="text-gray-800">{unit.type_LLave}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Nº Llave:</span>
                                  <span className="text-gray-800">{unit.number_LLave || '-'}</span>
                                </div>
                                <div className="flex">
                                  <span className="font-medium text-gray-600 w-32">Titular:</span>
                                  <span className="text-gray-800">{unit.titular_Breve || '-'}</span>
                                </div>
                              </div>
                            ) : (
                              <p className="text-gray-500 text-sm italic">No hay datos breve registrados</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ResidentialUnitsContainer;
